
import Header from "../../header";
import Footer from "../../footer";
import ContactForm from "../../contactcomponents/contactform";
import BannerFooter from "./bannerForFooter";
import uiuximage from '../../../images/footerLinksImages/productImage/uiuxdesign.jpg';
function UxDesign() {
    const features = [
        {
          title: "User Research & Analysis",
          description: "Understand your target audience with in-depth research and analysis to create designs that meet their needs and preferences.",
        },
        {
          title: "Wireframing & Prototyping",
          description: "Visualize the layout and flow of your application with interactive prototypes and detailed wireframes.",
        },
        {
          title: "Visual Design",
          description: "Craft stunning visual interfaces that captivate users and align with your brand identity.",
        },
        {
          title: "Interaction Design",
          description: "Design smooth and intuitive user interactions to enhance usability and engagement.",
        },
        {
          title: "Usability Testing",
          description: "Evaluate the functionality and user experience of your designs with real-world testing and feedback.",
        },
        {
          title: "Mobile-First Design",
          description: "Prioritize mobile usability with designs optimized for smaller screens and touch interfaces.",
        },
        {
          title: "Accessibility Design",
          description: "Ensure your application is usable by everyone, including people with disabilities, adhering to accessibility standards.",
        },
        {
          title: "Brand Consistency",
          description: "Maintain a consistent look and feel across your application, reflecting your brand’s core values.",
        },
        {
          title: "Responsive Design",
          description: "Deliver seamless experiences across all devices with designs that adapt fluidly to different screen sizes.",
        },
        {
          title: "UI Animation",
          description: "Add engaging animations and transitions that enhance the overall user experience.",
        },
      ];
    
    return (<>
        <Header />

        <BannerFooter
            title="Ui/Ux Design"
            text="UI/UX design services create intuitive interfaces and engaging user experiences for digital platforms. By prioritizing user needs, these services blend functionality and aesthetics to ensure smooth interactions. From wireframes to prototypes, they employ innovative design techniques to boost user satisfaction and retention. UI/UX design services help businesses stand out by delivering solutions that are both visually appealing and user-centric."
            imageone={uiuximage}
            imagetwo={uiuximage}
        />

<div className="container my-4">
      <h2 className="text-center mb-4">UI/UX Design Services</h2>
      <div className="accordion" id="accordionExample">
        {features.map((feature, index) => (
          <div className="accordion-item" key={index}>
            <h2 className="accordion-header" id={`heading${index}`}>
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapse${index}`}
                aria-expanded="false"
                aria-controls={`collapse${index}`}
              >
                {feature.title}
              </button>
            </h2>
            <div
              id={`collapse${index}`}
              className="accordion-collapse collapse"
              aria-labelledby={`heading${index}`}
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                {feature.description}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
        <ContactForm/>


        <Footer />
    </>)
}

export default UxDesign